import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='non-qualified-retirement-plan-intro'
    moduleName='intro-module'
    moduleVariation='A'
    // content
    headingText={
      <>
        What is a non&#45;qualified <WidowBlock>retirement plan&#63;</WidowBlock>
      </>
    }
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='button'>
          As an owner of a closely held business, you could already offer &#40;and participate in&#41; a qualified retirement plan such as a SEP, Simple or 401&#40;k&#41;. While they offer significant tax advantages, there are rules around contribution limits, minimum distributions, early withdrawals, and minimum vesting amounts. A non&#45;qualified retirement plan, however, doesn&#39;t have those limitations, can be tailored to the individual, and can help key employees build a nest egg much faster.
        </Typography>
        <Link
          id='non-qualified-retirement-plan-intro'
          variant='buttonLinkPrimary'
          linkUrl='/find-a-financial-advisor/'
          ariaLabel='Learn more about non&#45;qualified retirement plans from a financial advisor.'>
          Get started
        </Link>
      </>
    )}
  />
);
